module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAZCAMAAACM5megAAAAPFBMVEUAAAAAYGABZWABaGABZWABZmABZWABZWABZWABZWACZWABZGACZGABZWACZ2ABZWACaGAAcGAEZGABZWCCrdCXAAAAE3RSTlMAEM8ggN/fv3BQn++QYDCvQBBAX98S/gAAALxJREFUKM/NkdEOwiAMRS+0wNhgbvb//9XYMtkMxkc9bzQnbW/BvxKTA0CVmfOKMUG8wyRGnGnkkEosByNrjfKUMoFq0F75XcmLiEogwN20FV+VTRQdtzBc0Nd0Vihq7eZtp+lYfkPHi5JdtE5YWz7XnaU5iDYOJMYpXJE2v7TF7+0AOJG0lEDBpKrvQOj0IFSSHdOUC+RfaZ2l60qHLQlXTnbxffRjsxyoNIY4mVB03Ed2Itsp4RsuzfgFDyKvDrefjvkDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/icon-hide.png
// module id = c27e
// module chunks = 0